import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  medDomainBuildRowData: [],
  medDomainBuildSummaryData: [],
  medDomainBuildSummaryEisData: [],
  medDomainBuildDetailData: [],
  // Use null so we can distinguish "not loaded yet" from "loaded but empty"
  medDomainBuildDiffData: null,
};

export const medDomainSlice = createSlice({
  name: "medDomain.slice",
  reducerPath: "medDomain",
  initialState,
  reducers: {
    setMedDomainBuildRowData: (state, action) => {
      state.medDomainBuildRowData = action.payload;
    },
    setMedDomainBuildSummaryData: (state, action) => {
      state.medDomainBuildSummaryData = action.payload;
    },
    setMedDomainBuildSummaryEisData: (state, action) => {
      state.medDomainBuildSummaryEisData = action.payload;
    },
    setMedDomainBuildDetailData: (state, action) => {
      state.medDomainBuildDetailData = action.payload;
    },
    setMedDomainBuildDiffData: (state, action) => {
      state.medDomainBuildDiffData = action.payload;
    },
  },
});

export const {
  setMedDomainBuildRowData,
  setMedDomainBuildSummaryData,
  setMedDomainBuildSummaryEisData,
  setMedDomainBuildDetailData,
  setMedDomainBuildDiffData,
} = medDomainSlice.actions;
